import { ShiftStatus, ItineraryStatus } from '@caresend/types';
import { HOUR } from '@caresend/utils';
import { CardStyle } from '../../cards/BasicCard/model.js';
import '../portal/store/portal/sessionStore.js';
import 'vue';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/pinia/draftWaypoints/index.js';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

/**
 * For nurses only: the value of this determines the card message and style for
 * the itinerary "button". Listed in sequence.
 */
var NurseViewItineraryStatus;
(function (NurseViewItineraryStatus) {
    NurseViewItineraryStatus["NOT_ACCEPTED"] = "NOT_ACCEPTED";
    NurseViewItineraryStatus["CHECK_IN_INELIGIBLE"] = "CHECK_IN_INELIGIBLE";
    NurseViewItineraryStatus["CHECK_IN_ELIGIBLE"] = "CHECK_IN_ELIGIBLE";
    NurseViewItineraryStatus["CAN_VIEW_ITINERARY"] = "CAN_VIEW_ITINERARY";
})(NurseViewItineraryStatus || (NurseViewItineraryStatus = {}));
const getHoursBeforeShiftStart = (shiftStartTime) => (shiftStartTime - Date.now()) / HOUR;
const getAcceptedNurseItineraryStatusView = (shiftStartTime) => {
    const hoursBeforeShiftStart = getHoursBeforeShiftStart(shiftStartTime);
    const checkInThreshold = getStore().getters['variables/getShiftCheckInThreshold'];
    const hasCheckInThresholdPassed = hoursBeforeShiftStart > checkInThreshold;
    return hasCheckInThresholdPassed
        ? NurseViewItineraryStatus.CHECK_IN_INELIGIBLE
        : NurseViewItineraryStatus.CHECK_IN_ELIGIBLE;
};
const getNurseViewItineraryStatus = (shiftStatus, shiftStartTime) => {
    switch (shiftStatus) {
        case ShiftStatus.PENDING:
            return NurseViewItineraryStatus.NOT_ACCEPTED;
        case ShiftStatus.ACCEPTED:
            return getAcceptedNurseItineraryStatusView(shiftStartTime);
        default:
            return NurseViewItineraryStatus.CAN_VIEW_ITINERARY;
    }
};
const getDefaultItineraryStatusDisplay = (itineraryStatus) => {
    switch (itineraryStatus) {
        case ItineraryStatus.CANCELED:
            return {
                cardClass: 'ShiftItineraryCard__status--red',
                friendlyStatus: 'Canceled',
                cardStyle: CardStyle.DANGER,
            };
        case ItineraryStatus.CREATED:
        case ItineraryStatus.IN_PROGRESS:
        case ItineraryStatus.ACCEPTED:
            return {
                cardClass: 'ShiftItineraryCard__status--red',
                friendlyStatus: 'Pending',
                cardStyle: CardStyle.DANGER,
            };
        case ItineraryStatus.COMPLETED:
            return {
                cardClass: 'ShiftItineraryCard__status--green',
                friendlyStatus: 'Complete',
                cardStyle: CardStyle.GREEN,
            };
        default:
            return {
                cardClass: 'ShiftItineraryCard__status--red',
                friendlyStatus: 'Pending',
                cardStyle: CardStyle.DANGER,
            };
    }
};
const getNurseItineraryStatusDisplay = (nurseViewItineraryStatus) => {
    switch (nurseViewItineraryStatus) {
        case NurseViewItineraryStatus.CHECK_IN_INELIGIBLE:
            return {
                cardClass: 'ShiftItineraryCard__status--grey',
                friendlyStatus: 'Check in',
                cardStyle: CardStyle.GREY,
            };
        case NurseViewItineraryStatus.NOT_ACCEPTED:
        case NurseViewItineraryStatus.CHECK_IN_ELIGIBLE:
            return {
                cardClass: 'ShiftItineraryCard__status--blue',
                friendlyStatus: 'Check in',
                cardStyle: CardStyle.BLUE_100,
            };
        case NurseViewItineraryStatus.CAN_VIEW_ITINERARY:
            return {
                cardClass: 'ShiftItineraryCard__status--blue',
                friendlyStatus: 'Your itinerary',
                cardStyle: CardStyle.BLUE_100,
            };
    }
};

export { NurseViewItineraryStatus, getDefaultItineraryStatusDisplay, getNurseItineraryStatusDisplay, getNurseViewItineraryStatus };
